export var ECollectionNames;
(function (ECollectionNames) {
    ECollectionNames["WRONG_WAY_RESOLUTIONS"] = "wrong-way-resolutions";
})(ECollectionNames || (ECollectionNames = {}));
